import { BehaviorSubject } from 'rxjs';

export const gridActionclearActiveCells$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
